(function () {
  'use strict';

  var MAX_QTY = 99;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    (window.antennaUpgradeConfig || []).forEach(setupInstance);
  }

  // --- Shared modal, fully self-contained with unique class/attribute
  // names so it cannot collide with the theme's own modal system or
  // any other script on the page (e.g. Ymq, QuickCart). Built once and
  // reused for every row. ---
  var modalEl = null;
  var modalImageEl = null;
  var modalTitleEl = null;
  var modalTriggerEl = null; // element to restore focus to on close

  function getModal() {
    if (modalEl) return modalEl;

    modalEl = document.createElement('div');
    modalEl.className = 'antenna-image-modal';
    modalEl.setAttribute('data-antenna-image-modal', '');

    var backdrop = document.createElement('div');
    backdrop.className = 'antenna-image-modal__backdrop';
    backdrop.addEventListener('click', closeModal);

    var dialog = document.createElement('div');
    dialog.className = 'antenna-image-modal__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Antenna preview');

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'antenna-image-modal__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '\u00D7'; // ×
    closeBtn.addEventListener('click', closeModal);

    modalImageEl = document.createElement('img');
    modalImageEl.className = 'antenna-image-modal__image';
    modalImageEl.alt = '';

    modalTitleEl = document.createElement('p');
    modalTitleEl.className = 'antenna-image-modal__title';

    dialog.appendChild(closeBtn);
    dialog.appendChild(modalImageEl);
    dialog.appendChild(modalTitleEl);
    modalEl.appendChild(backdrop);
    modalEl.appendChild(dialog);
    document.body.appendChild(modalEl);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl.classList.contains('antenna-image-modal--visible')) {
        closeModal();
      }
    });

    return modalEl;
  }

  function openModal(imageUrl, title, triggerEl) {
    var modal = getModal();
    modalImageEl.src = imageUrl;
    modalImageEl.alt = title || '';
    modalTitleEl.textContent = title || '';
    modal.classList.add('antenna-image-modal--visible');
    document.body.classList.add('antenna-image-modal-open');
    modalTriggerEl = triggerEl || null;

    var closeBtn = modal.querySelector('.antenna-image-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    if (!modalEl || !modalEl.classList.contains('antenna-image-modal--visible')) return;
    modalEl.classList.remove('antenna-image-modal--visible');
    document.body.classList.remove('antenna-image-modal-open');
    if (modalTriggerEl && typeof modalTriggerEl.focus === 'function') {
      modalTriggerEl.focus();
    }
    modalTriggerEl = null;
  }
  // --- End shared modal ---

  function setupInstance(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return;

    if (!window.ProductAddonsCore) {
      console.error('antenna-upgrade-selector: ProductAddonsCore not found — make sure product-addons-core.js loads first');
      return;
    }

    var optionsContainer = root.querySelector('[data-antenna-upgrade-options]');
    var errorEl = root.querySelector('[data-antenna-upgrade-error]');
    var variants = config.variants || [];
    var quantities = {}; // sku -> current quantity, starts at 0 for all

    if (!variants.length) {
      showError('Antenna upgrade options are not configured correctly. Contact support.');
      console.error('antenna-upgrade-selector: no variants resolved — check the addon product handle and its metafield/SKUs');
      // Register anyway so this fails loudly instead of silently
      // shipping without any antenna upgrade options at all.
      window.ProductAddonsCore.register(root, function () {
        showError('Antenna upgrade options are not configured correctly. Contact support.');
        return { ok: false };
      });
      return;
    }

    renderRows();
    window.ProductAddonsCore.register(root, getContribution, getPriceContribution);

    function renderRows() {
      optionsContainer.innerHTML = '';
      variants.forEach(function (variant) {
        quantities[variant.sku] = 0;

        var row = document.createElement('div');
        row.className = 'antenna-upgrade-selector__row';

        var label = document.createElement('a');
        label.href = variant.url || '#';
        label.target = '_blank';
        label.rel = 'noopener';
        label.className = 'antenna-upgrade-selector__row-label fs-body-small';
        label.textContent = rowLabel(variant);

        if (variant.image) {
          label.addEventListener('click', function (e) {
            e.preventDefault();
            openModal(variant.image, variant.label || variant.sku, label);
          });
        }
        // No image on this variant: leave the link as a normal
        // new-tab link to the variant/product page instead of
        // silently doing nothing on click.

        var qtyWrap = document.createElement('div');
        qtyWrap.className = 'product__quantity antenna-upgrade-selector__qty';

        var subtractBtn = document.createElement('button');
        subtractBtn.type = 'button';
        subtractBtn.className = 'product__quantity-button antenna-upgrade-selector__qty-subtract';
        subtractBtn.setAttribute('aria-label', 'Decrease quantity for ' + (variant.label || variant.sku));
        subtractBtn.textContent = '\u2212'; // minus sign

        var input = document.createElement('input');
        input.type = 'number';
        input.className = 'product__input product__input--quantity antenna-upgrade-selector__qty-input';
        input.value = '0';
        input.min = '0';
        input.max = String(MAX_QTY);
        input.setAttribute('aria-label', 'Quantity for ' + (variant.label || variant.sku));

        var addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'product__quantity-button antenna-upgrade-selector__qty-add';
        addBtn.setAttribute('aria-label', 'Increase quantity for ' + (variant.label || variant.sku));
        addBtn.textContent = '+';

        subtractBtn.addEventListener('click', function () {
          setQuantity(variant.sku, quantities[variant.sku] - 1, input);
        });
        addBtn.addEventListener('click', function () {
          setQuantity(variant.sku, quantities[variant.sku] + 1, input);
        });
        input.addEventListener('change', function () {
          setQuantity(variant.sku, parseInt(input.value, 10), input);
        });

        qtyWrap.appendChild(subtractBtn);
        qtyWrap.appendChild(input);
        qtyWrap.appendChild(addBtn);

        row.appendChild(label);
        row.appendChild(qtyWrap);
        optionsContainer.appendChild(row);
      });
    }

    function setQuantity(sku, rawValue, input) {
      var value = rawValue;
      if (isNaN(value) || value < 0) value = 0;
      if (value > MAX_QTY) value = MAX_QTY;
      quantities[sku] = value;
      input.value = String(value);
      clearError();
      if (window.ProductAddonsCore && window.ProductAddonsCore.notifyChange) window.ProductAddonsCore.notifyChange(root);
    }

    function rowLabel(variant) {
      var name = (variant.label && variant.label !== 'Default Title') ? variant.label : variant.sku;
      return name + ' (' + formatMoney(variant.price) + ' each)';
    }

    // Live price preview only — no validation, no error UI.
    function getPriceContribution() {
      var total = 0;
      variants.forEach(function (v) {
        total += Number(v.price) * (quantities[v.sku] || 0);
      });
      return total;
    }

    // Called by ProductAddonsCore when the shopper clicks add-to-cart.
    // Always ok: this option is entirely optional, all-zero is valid.
    function getContribution() {
      var items = variants
        .filter(function (v) { return quantities[v.sku] > 0; })
        .map(function (v) {
          return {
            id: v.variantId,
            quantity: quantities[v.sku],
            properties: { 'Antenna': v.label || v.sku }
          };
        });

      clearError();
      return { ok: true, items: items };
    }

    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function clearError() { errorEl.textContent = ''; errorEl.hidden = true; }
    function formatMoney(amount) { return '$' + Number(amount).toFixed(2); }
  }
})();